<template>
	<div>
		<div v-if="nothingData && !nothingData.inSelect" class="mb-2">
			<b-form-checkbox v-model="nothing" @change="nothingChanged">{{ nothingData.text }}</b-form-checkbox>
			<div v-if="!nothing && (!selected || selected.length === 0)" class="error">{{ nothingData.error }}</div>
		</div>
		<b-select
			v-model="selected"
			:options="options"
			:class="{'smaller': smaller}"
			@input="selectedChanged"
			@change="$emit('change')"
		>
			<template v-if="selected === undefined" #first>
				<b-form-select-option :value="undefined">{{ undefinedTextOptionText }}</b-form-select-option>
			</template>
		</b-select>
	</div>
</template>

<script>
import _ from "lodash";
import * as Label from "@/helper/characteristic/Label";
import {byId} from "@/helper/application/characteristic/Provider";
import {isDefined} from "@/helper/Value";

const SORT_OPTIONS_TYPE_LABEL = 'label';
const SORT_OPTIONS_TYPE_SORT = 'sort';

export default {

	props: {
		value: {
			type: Object,
			required: false,
		},
		initialValue: {
			type: Object,
			required: false,
		},
		characteristics: {
			type: Array,
			required: true,
		},
		nothingData: {
			type: Object,
			required: false,
		},
		withEmptyOption: {
			type: String,
			required: false,
		},
		undefinedTextOptionText: {
			type: String,
			required: false,
			default: '--- Bitte triff eine Auswahl --'
		},
		onlyFirstLevel: {
			type: Boolean,
			required: false,
			default: false,
		},
		onlyLastLevel: {
			type: Boolean,
			required: false,
			default: false,
		},
		excludeIds: {
			type: Array,
			required: false,
		},
		labelType: {
			type: String,
			required: false,
		},
		smaller: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		let selected = undefined;

		if (this.value === null)
		{
			selected = null;
		}

		if (isDefined(this.value))
		{
			selected = byId(this.value.id, this.characteristics);
		}

		if (isDefined(this.initialValue))
		{
			selected = byId(this.initialValue.id, this.characteristics);
		}

		return {
			nothing: this.value === null,
			selected,
		};
	},

	computed: {
		options ()
		{
			let options = this.getOptions(this.characteristics, 0);

			if (this.nothingData && this.nothingData.inSelect)
			{
				options.unshift({
					value: null,
					text: this.nothingData.text
				});
			}

			if (this.onlyLastLevel)
			{
				this.sortOptions(options, SORT_OPTIONS_TYPE_LABEL);
			}

			return options;
		}
	},

	methods: {
		nothingChanged (checked)
		{
			if (checked)
			{
				this.selected = undefined;
			}

			this.emitChangeEvent();
		},
		selectedChanged (value)
		{
			if (value)
			{
				if (!value.nothing)
				{
					this.nothing = false;
				}
			}

			this.emitChangeEvent();
		},
		getItemLabel (item)
		{
			return Label.get(item, this.labelType);
		},
		emitChangeEvent ()
		{
			this.$emit(
				'input',
				this.nothing || this.selected === null
					? null
					: this.selected
			);
		},
		getOptions (items, level)
		{
			let options = [];

			if (this.withEmptyOption)
			{
				options.push({
					value: null,
					text: this.withEmptyOption,
				});
			}

			let filteredItems = _.filter(
				items,
				item =>
				{
					return !(this.excludeIds && _.includes(this.excludeIds, item.id));
				}
			);

			_.forEach(filteredItems, item =>
			{
				if (!this.onlyLastLevel || item.children.length === 0)
				{
					options.push({
						value: item,
						text: this.onlyLastLevel
							? this.getItemLabel(item)
							: ('--'.repeat(level) + ' ' + this.getItemLabel(item)),
						disabled: !this.onlyFirstLevel && item.children.length > 0
					});
				}

				if (item.children.length > 0 && !this.onlyFirstLevel)
				{
					options = _.concat(
						options,
						this.getOptions(item.children, level + 1)
					);
				}
			});

			this.sortOptions(options, SORT_OPTIONS_TYPE_SORT);

			return options;
		},
		sortOptions (options, sortType)
		{
			options.sort((a, b) =>
			{
				if (a.value && !b.value)
				{
					return 1;
				}

				if (!a.value && b.value)
				{
					return -1;
				}

				if (sortType === SORT_OPTIONS_TYPE_SORT)
				{
					if (a.value.sort !== null && b.value.sort === null)
					{
						return -1;
					}

					if (a.value.sort === null && b.value.sort !== null)
					{
						return 1;
					}

					return a.value.sort < b.value.sort ? -1 : 1;
				}

				if (sortType === SORT_OPTIONS_TYPE_LABEL)
				{
					const labelA = this.getItemLabel(a.value);
					const labelB = this.getItemLabel(b.value);

					return labelA.localeCompare(labelB, 'de', { numeric: true });
				}
			});
		}
	}
}
</script>
